import React from 'react';
export function SiteFooter() {
  return <footer className="bg-navy px-4 py-10 sm:px-6" data-id="element-117" data-mp="1dqrohw3lfk7t">
      <div className="mx-auto w-full max-w-[42rem] text-center lg:max-w-3xl" data-id="element-118" data-mp="3r7pxdxcwyf51">
        <p className="text-[0.85rem] font-semibold text-white" data-id="element-119" data-mp="3mhj7zvakuqlq">
          Girls Flag Football Coach System™
        </p>
        <p className="mx-auto mt-2.5 max-w-xl text-[0.74rem] leading-relaxed text-white/55" data-id="element-120" data-mp="3hizijkwrywom">
          A digital, written coaching system for Girls Flag Football coaches. It
          supports practice organization and coaching decisions and does not
          replace your own judgment, player safety decisions, or the rules of
          your specific league or organization, which always take priority.
        </p>
        <p className="mt-4 text-[0.7rem] text-white/35" data-id="element-121" data-mp="2yknak2hlnsum">
          © {new Date().getFullYear()} Girls Flag Football Coach System™. All
          rights reserved.
        </p>
      </div>
    </footer>;
}